import cn from 'classnames';

interface ContentProps {
  children: React.ReactNode;
  className?: string;
}

const Content: React.FC<ContentProps> = ({ className, children }) => {
  if (!children) return null;

  return <div className={cn('content-with-sidebar--content', className)}>{children}</div>;
};

Content.displayName = 'Content';

export default Content;
